export default __webpack_public_path__ + "images/f01278d6862b5a41aefd838d21e0320b-perú_flag.png";